import { logDevelopmentMessage } from './logDevelopmentMessage';
export var logDeprecationMessage = function (message) {
    logDevelopmentMessage("DEPRECATION WARNING: ".concat(message));
};
//# sourceMappingURL=logDeprecationMessage.js.map